<script setup lang="ts">
  import { Badge } from '@gat-ship/vue-components'
  import { type TenantUser } from '@gat-ship/types'
  import {
    TooltipProvider,
    Tooltip,
    TooltipTrigger,
    TooltipContent
  } from '@gat-ship/vue-components'
  import { type HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  import { IconAdmin } from '@gat-ship/icons'
  const props = defineProps<{
    tenantUser?: TenantUser
    class?: HTMLAttributes['class']
  }>()
</script>

<template>
  <TooltipProvider v-if="props.tenantUser?.isTenantAdmin">
    <tooltip>
      <TooltipTrigger as-child>
        <badge
          :class="
            cn(
              'text-muted-foreground flex w-fit items-center gap-1 bg-transparent px-2 py-0 text-xs ring-yellow-500',
              props.class
            )
          "
          variant="outline"
          @click.stop
        >
          <icon-admin class="size-3.5" />
          Admin
        </badge>
      </TooltipTrigger>
      <TooltipContent> Tenant Admin </TooltipContent>
    </tooltip>
  </TooltipProvider>
</template>
